import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useContext,
} from "react";
import AppContext from "../AppContext";
// import "./index.css";
import styles from "./NavBar.module.css";
import { AiOutlineMenu } from "react-icons/ai";
import { FaBars } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
// import { userouter.push, Link, useLocation } from "react-router-dom";
import { gtag_report_conversion } from "../../utils/gtag_report_conversion";
import { createStripeSubscriptionUS } from "../../utils/stripe";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import Logo from "../../assets/clm/BoloSign.png";
import {
  BASE_ASSETS_URL,
  BASE_URL,
  BUSINSESS_PLAN_YEARLY_DEAL,
} from "../../constants/constants";
import { contractsForNavbar } from "../../constants/contracts";
import { BiChevronRight, BiLinkExternal } from "react-icons/bi";
import { FaArrowRight } from "react-icons/fa";
import {
  ButtonPrimary,
  ButtonPrimaryDiv,
  ButtonSecondary,
  ButtonSecondaryDiv,
} from "@components/Buttons";
import { HiArrowLongRight } from "react-icons/hi2";
import { BsArrowRight } from "react-icons/bs";

import useDeviceSize from "../../utils/useDeviceSize";
import {
  createUTMQueryParams,
  is1DollarTrialCampaign,
} from "@utils/signature_owner";
import SignatureRegister from "components/SignatureRegister";
import { Button1 } from "@components/google-ads/Buttons";
import { TbMathGreater } from "react-icons/tb";
import {
  CLMButtonPrimary1,
  CLMButtonPrimaryArrow,
} from "components/CLM/v3/Buttons";
import CustomNavLink from "./CustomNavLink";
import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const bgColors = [
  "bg-green-200",
  "bg-yellow-200",
  "bg-red-200",
  "bg-gray-200",
  "bg-blue-200",
  "bg-purple-200",
  "bg-indigo-200",
];

const gsuiteProducts = [
  {
    image: "esignature-icon.svg",
    title: "BoloSign eSignature",
    description:
      "Securely collect legally binding signatures directly within Google Forms.",
    link: "/signature/gsuite-addon/esignature/",
  },
  {
    image: "fillable-icon.png",
    title: "Fillable PDF",
    description:
      "Generate customized, fillable PDFs from Google Forms responses with ease.",
    link: "/signature/gsuite-addon/fillable/",
  },
  {
    image: "embeddings-icon.png",
    title: "Embed in Website",
    description:
      "Easily embed BoloSign directly into your website for seamless integration.",
    link: "/signature/gsuite-addon/embeddings/",
  },
  {
    image: "signature-workflow-icon.png",
    title: "Signature Workflow",
    description:
      "Manage and collect multiple signatures seamlessly in your Google Forms.",
    link: "/signature/gsuite-addon/signature-workflow/",
  },
  {
    image: "file-upload-icon.png",
    title: "File Upload",
    description:
      "Allow users to upload files directly in Google Forms without needing to log in.",
    link: "/signature/gsuite-addon/file-upload/",
  },
  {
    image: "payment-form-icon.svg",
    title: "Payment Form",
    description:
      "Easily accept payments directly within your Google Forms using Stripe.",
    link: "/signature/gsuite-addon/payment/",
  },
];

const Navbar = ({ refs }) => {
  let router = useRouter();
  let pathname = router.pathname;
  const navbarRef = useRef();
  const [width] = useDeviceSize();
  // const context = useContext(AppContext);
  const context = useContext(AppContext);
  useEffect(() => {
    let country = localStorage.getItem("country");
    country && setIsIndianPrice(country === "IN");

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // (async function () {
  //   if (pathname.includes("/signature/contracts")) {
  //     const response = await fetch(`${BASE_URL}contracts-for-navbar`);
  //     const data = await response.json();
  //     console.log(data);
  //   }
  // })();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductsMenuOpen, setIsProductsMenuOpen] = useState(false);
  const [isCompareMenuOpen, setIsCompareMenuOpen] = useState(false);

  const [isSolutionsMenuOpen, setIsSolutionsMenuOpen] = useState(false);
  const [isContractsMenuOpen, setIsContractsMenuOpen] = useState("");
  const [isGsuiteProductsOpen, setIsGsuiteProductsOpen] = useState(false);
  const [isMobileGsuitProductsOpen, setIsMobileGsuitProductsOpen] =
    useState(false);

  const [isIndianPrice, setIsIndianPrice] = useState(false);

  const [isSubscriptionDealPage, setIsSubscriptionDealPage] = useState(
    pathname?.includes("/mega-subscription-deal") ||
      pathname?.includes("/ultimate-subscription-deal") ||
      pathname?.includes("/limited-subscription-deal")
  );

  const [isDealPage, setDealPage] = useState(
    pathname?.includes("/super-lifetime-deal") ||
      pathname?.includes("/lifetime-deal") ||
      pathname?.includes("/mega-subscription-deal") ||
      pathname?.includes("/ultimate-subscription-deal") ||
      pathname?.includes("/limited-subscription-deal") ||
      pathname?.includes("/super-lifetime-deal")
  );
  const [signaturePopup, setSignaturePopup] = useState({
    open: false,
    mode: "register",
  });
  const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] =
    useState(false);

  const handleOutsideClick = (e) => {
    if (navbarRef.current !== null) {
      if (navbarRef.current.contains(e.target)) return;
    }
    setIsProductsMenuOpen(false);
    setIsCompareMenuOpen(false);
    setIsSolutionsMenuOpen(false);
    setIsContractsMenuOpen("");
  };

  const handleGetPremiumFree = () => {
    pathname?.includes("/form-approval") || pathname === "/"
      ? pathname?.includes("pricing")
        ? isIndianPrice
          ? window.open("https://buy.stripe.com/fZeeWg38Z9bY95S299", "_self")
          : window.open("https://buy.stripe.com/bIY6pKfVL2NAbe0eVT", "_self")
        : router.push("/form-approval/pricing")
      : pathname?.includes("pricing")
      ? isIndianPrice
        ? window.open(
            "https://buy.stripe.com/cN26pKfVLdse3LyfZF?prefilled_promo_code=TIMEOFF",
            "_self"
          )
        : window.open(
            "https://buy.stripe.com/7sI01m6lb9bY3Ly8x1?prefilled_promo_code=TIMEOFF",
            "_self"
          )
      : pathname?.includes("/signature")
      ? router.push("/signature/pricing")
      : router.push("/timer-classroom/pricing");
  };

  const approvalAddonUrl =
    "https://workspace.google.com/marketplace/app/form_approvals_publisher_notifications_d/674195424545?ref=website";
  const timerAddonUrl =
    "https://workspace.google.com/u/5/marketplace/app/timer_+_proctor_form_presenter+timer_for/1083655933830?ref=website";
  const signatureAddonUrl =
    "https://workspace.google.com/u/0/marketplace/app/singature_by_boloforms/980217179187?ref=website";

  const getAddonUrl = (productName) => {
    switch (productName) {
      case "form-approval":
        return approvalAddonUrl;
      case "timer-classroom":
        return timerAddonUrl;
      case "signature":
        return signatureAddonUrl;

      default:
        return approvalAddonUrl;
    }
  };

  const getGuideUrl = (productName) => {
    switch (productName) {
      case "form-approval":
        return "https://approval-docs.boloforms.com/";
      case "timer-classroom":
        return "https://timer-docs.boloforms.com";
      case "signature":
        return "https://help.boloforms.com/";
      case "blog-genie":
        return "https://blog-genie-doc.boloforms.com/";
      default:
        return "https://signature-docs.boloforms.com/";
    }
  };

  const getBlogsUrl = () => {
    const blogUrl = "/blog/page/1";
    switch (true) {
      case pathname.includes("/form-approval"):
        return blogUrl + "/approvals";
      case pathname.includes("/signature"):
        return blogUrl + "/signature";
      case pathname.includes("/timer-classroom"):
        return blogUrl + "/timer-proctor";
      default:
        return blogUrl + "/signature";
    }
  };

  const handleGuideClick = () => {
    switch (true) {
      case pathname.includes("/form-approval"):
        window.open("https://approval-docs.boloforms.com/", "_blank");
        break;
      case pathname.includes("/timer-classroom"):
        window.open("https://timer-docs.boloforms.com", "_blank");
        break;
      case pathname.includes("/signature/api"):
        window.open("https://developer.boloforms.com/", "_blank");
        break;
      case pathname.includes("/signature"):
        window.open(
          "https://help.boloforms.com/en/collections/19658045-dashboard",
          "_blank"
        );
        break;
      case pathname.includes("/blog-genie"):
        window.open("https://blog-genie-doc.boloforms.com/", "_blank");
        break;
      default:
        window.open(
          "https://help.boloforms.com/en/collections/19658045-dashboard",
          "_blank"
        );
    }
    setIsMobileMenuOpen(false);
  };

  const isPaidProduct =
    pathname?.includes("/form-approval") ||
    pathname === "/" ||
    pathname?.includes("/timer-classroom") ||
    pathname?.includes("/signature") ||
    pathname?.includes("/features") ||
    pathname?.includes("/customers");

  // useEffect(() => {
  //   let country = localStorage.getItem("country");
  //   country && setIsIndianPrice(country === "IN");

  //   document.addEventListener("mousedown", handleOutsideClick);
  //   return () => {
  //     document.removeEventListener("mousedown", handleOutsideClick);
  //   };
  // }, []);

  const renderProductLink =
    pathname?.includes("/") && !pathname?.includes("/tattoo-forms");

  const renderSolutionLink =
    pathname?.includes("/form-approval") &&
    !pathname?.includes("/tattoo-forms") &&
    !pathname?.includes("/timer-classroom") &&
    !pathname?.includes("/signature") &&
    !pathname?.includes("/blog");

  const renderPricingLink =
    (pathname?.includes("/") ||
      pathname?.includes("/form-approval") ||
      pathname?.includes("/timer-classroom") ||
      (pathname?.includes("/signature") &&
        !pathname?.includes("/signature/contracts") &&
        !pathname.includes("/blog-genie") &&
        !pathname?.includes("/blog"))) &&
    !isDealPage;

  const renderTemplateLink =
    pathname?.includes("/") &&
    !pathname?.includes("/blog-genie") &&
    !pathname?.includes("/tattoo-forms") &&
    !pathname?.includes("/timer-classroom") &&
    !pathname?.includes("/signature") &&
    !pathname?.includes("/blog");

  const renderContractsLink = pathname?.includes("/signature/contracts");

  const renderContractsNavLink =
    !pathname?.includes("/signature/contracts") &&
    !pathname?.includes(
      "/signature/not-used-lifetime-pages/lifetime-plan-new"
    ) &&
    !isDealPage;

  const renderFeatureLink =
    pathname?.includes("/form-approval") &&
    !pathname?.includes("/blog-genie") &&
    !pathname?.includes("/tattoo-forms") &&
    !pathname?.includes("/timer-classroom") &&
    !pathname?.includes("/signature") &&
    !pathname?.includes("/blog");

  const renderGuidesLink =
    (pathname?.includes("/") ||
      pathname?.includes("/form-approval") ||
      pathname?.includes("/signature") ||
      pathname?.includes("/timer-classroom")) &&
    !pathname?.includes("/contracts") &&
    !isDealPage;

  const renderSecurityLink = pathname?.includes("/") && !isDealPage;

  const renderBlogsLink =
    (pathname?.includes("/") ||
      pathname?.includes("/form-approval") ||
      pathname?.includes("/signature") ||
      pathname?.includes("/timer-classroom")) &&
    !pathname.includes("/contracts") &&
    !pathname.includes(
      "/signature/not-used-lifetime-pages/lifetime-plan-new"
    ) &&
    !isDealPage;

  const renderIndexLinks =
    pathname?.includes("/") &&
    !pathname?.includes("/form-approval") &&
    !pathname?.includes("/signature") &&
    !pathname?.includes("/timer-classroom");

  const renderBtns =
    pathname?.includes("/") ||
    pathname?.includes("/form-approval") ||
    pathname?.includes("/signature") ||
    pathname?.includes("/timer-classroom");

  const renderGsuiteProducts = pathname.includes("/gsuite-addon");

  function trackAdWords() {
    window.open(getAddonUrl(pathname.slice(1)), "_blank");
    gtag_report_conversion();
  }

  const renderRoadmapLink =
    (pathname?.includes("/") || pathname?.includes("/signature")) &&
    !isDealPage;

  const handleRoadmapClick = () => {
    switch (true) {
      case pathname.includes("/signature"):
        window.open("https://boloforms.canny.io/", "_self");
        break;
      default:
        window.open("https://boloforms.canny.io/", "_self");
    }
  };

  const handlePricingClick = () => {
    switch (true) {
      case pathname.includes("/tattoo-forms"):
        router.push("/tattoo-forms/pricing");
        break;
      case pathname.includes("/form-approval"):
        router.push("/form-approval/pricing");
        break;
      case pathname.includes("/signature/api"):
        router.push("/signature/api#pricing");
        break;
      case pathname.includes("/signature"):
        router.push("/signature/pricing");
        // window.open("https://signature.boloforms.com/billings")
        break;
      case pathname.includes("/timer-classroom"):
        router.push("/timer-classroom/pricing");
        break;
      default:
        router.push("/signature/pricing");
    }
    setIsMobileMenuOpen(false);
  };

  const handleSignInUp = () => {
    switch (true) {
      case pathname.includes("signature"):
        window.open(
          `https://signature.boloforms.com/login?from=${
            context.globalData.from || "WEBSITE_NAV_BAR"
          }${createUTMQueryParams({
            utmData_: context.globalData.utmData,
            from: "WEBSITE_NAV_BAR",
          })}`,
          "_blank"
        );
        break;
      case pathname.includes("timer-classroom"):
        window.open("https://dashboard.boloforms.com", "_blank");
        break;
      case pathname.includes("tattoo-forms"):
        window.open(
          `https://approval-dashboard.boloforms.com/login?from=${
            context.globalData.from || "TATTOO_TEAMPLTES_ADS"
          }`,
          "_blank"
        );
        break;
      case pathname.includes("blog-genie"):
        window.open("https://ytbg.boloforms.com/", "_blank");
        break;
      case pathname.includes("form-approval"):
        trackAdWords();
        break;
      default:
        window.open(
          `https://signature.boloforms.com/login?from=${
            context.globalData.from || "WEBSITE_NAV_BAR"
          }${createUTMQueryParams({
            utmData_: context.globalData.utmData,
            from: "WEBSITE_NAV_BAR",
          })}`,
          "_blank"
        );
    }
    setIsMobileMenuOpen(false);
  };

  const handleGetStartedClick = () => {
    let signUpUrl;
    switch (true) {
      case pathname.includes("signature"):
        signUpUrl = `https://signature.boloforms.com/register?from=${
          context.globalData.from || "NAV_BAR"
        }${createUTMQueryParams({
          utmData_: context.globalData.utmData,
          from: "NAV_BAR",
        })}`;
        break;
      default:
        signUpUrl =
          signUpUrl = `https://signature.boloforms.com/register?from=${
            context.globalData.from || "NAV_BAR"
          }${createUTMQueryParams({
            utmData_: context.globalData.utmData,
            from: "NAV_BAR",
          })}`;
        break;
    }
    window.open(signUpUrl, "_blank");
    setIsMobileMenuOpen(false);
  };

  const handleDemoClick = () => {
    let demoURL;

    switch (true) {
      case pathname.includes("signature"):
        demoURL = "https://cal.com/boloforms/signature";
        break;
      case pathname.includes("timer-classroom"):
        demoURL = "https://cal.com/boloforms/boloforms-proctor-demo";
        break;
      case pathname.includes("/tattoo-forms"):
        demoURL = "https://cal.com/boloforms/tattoo-form-demo";
        break;
      default:
        demoURL = "https://cal.com/boloforms/signature";
    }

    window.open(demoURL, "_blank");
    setIsMobileMenuOpen(false);
  };

  const handleHomeClick = () => {
    let homePageLink;
    switch (true) {
      case pathname.includes("form-approval"):
        homePageLink = "/form-approval";
        break;
      case pathname.includes("signature"):
        homePageLink = "/";
        break;
      case pathname.includes("timer-classroom"):
        homePageLink = "/timer-classroom";
        break;
      case pathname.includes("/tattoo-forms"):
        homePageLink = "/tattoo-forms";
        break;
      case pathname.includes("blog-genie"):
        homePageLink = "/blog-genie";
        break;
      default:
        homePageLink = "/";
    }

    router.push(homePageLink);
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    setIs1DollarTrialCampaignState(
      is1DollarTrialCampaign({
        utm_campaign: context?.globalData?.utmData?.utm_campaign,
      })
    );
  }, [context?.globalData?.utmData?.utm_campaign]);

  return (
    <div ref={navbarRef}>
      <SignatureRegister
        setIsPopupOpen={(value) =>
          setSignaturePopup((prev) => ({ ...prev, open: value }))
        }
        isPopupOpen={signaturePopup.open}
        mode={signaturePopup.mode}
        setMode={(mode) =>
          setSignaturePopup((prev) => ({ ...prev, mode: mode }))
        }
      />
      <div className="bg-black flex justify-center md:justify-between items-center fixed top-0 left-0 right-0 z-20 px-4 sm:p-4 overflow-hidden h-8">
        <div className="hidden md:block text-white text-xs">
          <Link
            href="/signature/pricing"
            className="flex items-center hover:text-gray-300"
          >
            Buy Now
            <BiChevronRight className="text-2xl" />
          </Link>
        </div>
        <div className="flex flex-row items-center">
          <a
            href={`tel:+14156496611`}
            className="text-white hover:text-gray-300 text-xs flex items-center gap-2"
          >
            Sales: +1 (415) 6496611
          </a>
          <button
            onClick={() => {
              setSignaturePopup({ open: true, mode: "login" });
            }}
            className="ml-4 mr-1.5 text-white hover:text-gray-300 text-xs hidden md:block"
          >
            Sign In
          </button>
        </div>
      </div>
      <div
        className={`w-full bg-white justify-center items-center fixed top-8 left-0 right-0 z-20 h-20 sm:p-4 overflow-hidden border-b border-gray-200 flex  `}
      >
        <div
          className={`flex items-center justify-between max-w-[1350px] w-full h-full  flex-row lg:justify-start md:px-0 px-4`}
        >
          <div
            onClick={handleHomeClick}
            className="flex flex-row items-center cursor-pointer md:mr-10 mr-4 sm:ml-4 ml-0"
          >
            {pathname.includes("/blog-genie") ? (
              <Image
                src={`${BASE_ASSETS_URL}/boloforms/blogGenie.png`}
                loading="lazy"
                alt=""
                className="h-12 w-auto"
                width={10}
                height={10}
              />
            ) : (
              <Image
                src={Logo}
                loading="lazy"
                alt=""
                className="h-6 w-auto"
                width={100}
                height={100}
              />
            )}
          </div>

          <div className={`space-x-8 items-center h-full lg:flex hidden`}>
            {/* {renderProductLink && (
              <span
                onMouseEnter={() => {
                  setIsProductsMenuOpen(true);
                  setIsContractsMenuOpen("");
                  setIsSolutionsMenuOpen(false);
                  setIsCompareMenuOpen(false);
                  setIsMobileMenuOpen(false);
                }}
                onMouseLeave={() => {
                  setIsProductsMenuOpen(false);
                }}
                className={`mr-8 text-base font-medium cursor-pointer flex flex-row items-center`}
              >
                Products <MdKeyboardArrowDown className="text-xl ml-1" />
              </span>
            )} */}
            {renderSolutionLink && (
              <span
                onMouseEnter={() => {
                  setIsSolutionsMenuOpen(true);
                  setIsProductsMenuOpen(false);
                  setIsContractsMenuOpen("");
                  setIsCompareMenuOpen(false);
                  setIsMobileMenuOpen(false);
                }}
                onMouseLeave={() => {
                  setIsSolutionsMenuOpen(false);
                }}
                className={`text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer flex justify-center items-center gap-1`}
              >
                Solutions <MdKeyboardArrowDown className="text-xl" />
              </span>
            )}
            {renderFeatureLink && (
              <CustomNavLink
                href={"/features"}
                target="_blank"
                rel="noreferrer"
                className="text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer"
              >
                Features
              </CustomNavLink>
            )}

            {renderContractsLink &&
              Object.keys(contractsForNavbar).map((nav, index) => (
                <CustomNavLink
                  key={index}
                  rel="noreferrer"
                  onClick={() =>
                    isContractsMenuOpen === nav
                      ? setIsContractsMenuOpen("")
                      : setIsContractsMenuOpen(nav)
                  }

                  // className="mr-10 text-base font-medium cursor-pointer hover:text-gray-600"
                  // onMouseEnter={() => {
                  //   setIsContractsMenuOpen(nav);
                  //   setIsProductsMenuOpen(false);
                  //   setIsSolutionsMenuOpen(false);
                  //   setIsCompareMenuOpen(false);
                  //   setIsMobileMenuOpen(false);
                  // }}
                  // onMouseLeave={() => {
                  //   setIsContractsMenuOpen("");
                  // }}
                >
                  {" "}
                  {nav} <MdKeyboardArrowDown className="text-xl  mt-1" />
                </CustomNavLink>
              ))}

            {renderGuidesLink && (
              <CustomNavLink
                onClick={handleGuideClick}
                rel="noreferrer"
                className="text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer"
              >
                Guides
              </CustomNavLink>
            )}

            {renderSecurityLink && (
              <CustomNavLink
                href={`https://security.boloforms.com/`}
                onClick={() => setIsMobileMenuOpen(false)}
                rel="noreferrer"
                className="text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer"
              >
                Security
              </CustomNavLink>
            )}

            {/* {renderBlogsLink && (
              <Link
                href={getBlogsUrl()}
                onClick={() => setIsMobileMenuOpen(false)}
                rel="noreferrer"
                className="mr-10 text-lg cursor-pointer my-auto"
              >
                Blogs
              </Link>
            )} */}

            {renderIndexLinks && (
              <CustomNavLink
                href={"/about"}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About Us
              </CustomNavLink>
            )}

            {renderIndexLinks && (
              <CustomNavLink
                href={"/customers"}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Case Studies
              </CustomNavLink>
            )}

            {/* {!pathname?.includes("/signature/enterprise") &&
              renderContractsNavLink && (
                <span
                  onClick={() => router.push("/signature/contracts")}
                  target="_blank"
                  rel="noreferrer"
                  className="mr-10 text-lg cursor-pointer my-auto"
                >
                  Contracts
                </span>
              )} */}
            {renderRoadmapLink && (
              <CustomNavLink
                onClick={handleRoadmapClick}
                target="_blank"
                rel="noreferrer"
                className="text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer"
              >
                Roadmap
              </CustomNavLink>
            )}
            {renderGsuiteProducts && (
              <CustomNavLink
                rel="noreferrer"
                className={`text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer`}
                onClick={() => setIsGsuiteProductsOpen((prev) => !prev)}
              >
                Products <MdKeyboardArrowDown className="text-xl ml-1" />
              </CustomNavLink>
            )}
          </div>

          {renderBtns && (
            <div
              className={`${styles.navbar_item_buttons} ml-auto flex justify-center items-center gap-8 text-gray-800`}
            >
              {renderPricingLink &&
                !pathname?.includes(
                  "/signature/not-used-lifetime-pages/lifetime-plan-new"
                ) &&
                !pathname?.includes("/signature/enterprise") && (
                  <div className="lg:flex hidden">
                    <CustomNavLink
                      onClick={handlePricingClick}
                      href={"/signature/pricing"}
                      rel="noreferrer"
                    >
                      Pricing
                    </CustomNavLink>
                  </div>
                )}
              {/* <span
                onClick={handleSignInUp}
                target="_blank"
                rel="noreferrer"
                className="text-lg cursor-pointer my-auto hidden lg:block"
              >
                Login
              </span>
              <button
                onClick={handleGetStartedClick}
                className={`${
                  styles.navbar_item_primary_button
                } font-sans hover:opacity-90 flex justify-center items-center gap-2 ${
                  pathname.includes("/blog-genie")
                    ? "border-2 border-green-400 bg-green-400 text-white"
                    : "bg-[#915bff] text-white border-2 border-violet-500"
                }`}
              >
                Get Started <FaArrowRight />
              </button> */}
              {!isDealPage && (
                <div className="hidden xlg:flex items-center gap-4">
                  {/* {is1DollarTrialCampaignState ? (
                    <Button1
                      btnText={`Sign In`}
                      bgColor="bg-white"
                      textColor="text-black"
                      border="border border-black"
                      showLoading={false}
                    />
                  ) : (
                    <ButtonSecondaryDiv
                      buttonText={`Sign In`}
                      onclick={() =>
                        setSignaturePopup((prev) => ({
                          ...prev,
                          open: true,
                          mode: "login",
                        }))
                      }
                      // buttonUrl={`https://signature.boloforms.com/login?from=${
                      //   context.globalData.from || "WEBSITE_NAVBAR"
                      // }`}
                      // newTab={false}
                    />
                  )} */}
                  {!pathname?.includes("/signature/enterprise") &&
                    !pathname?.includes("/demo-booked") &&
                    (is1DollarTrialCampaignState ? (
                      <Button1
                        btnText={`Sign Up`}
                        bgColor="bg-violet-500"
                        textColor="text-white"
                        border="border border-violet-500  "
                        showLoading={false}
                      />
                    ) : (
                      <CLMButtonPrimary1
                        buttonText={`Sign Up`}
                        onClick={() =>
                          setSignaturePopup((prev) => ({
                            ...prev,
                            open: true,
                            mode: "register",
                          }))
                        }
                        icon={<HiArrowLongRight />}
                      />
                      // <ButtonPrimaryDiv
                      //   buttonText={`Sign Up`}
                      //   onclick={() =>
                      //     setSignaturePopup((prev) => ({
                      //       ...prev,
                      //       open: true,
                      //       mode: "register",
                      //     }))
                      //   }
                      //   borderShadow={false}
                      //   // buttonUrl={`https://signature.boloforms.com/register?from=${
                      //   //   context.globalData.from || "WEBSITE_NAVBAR"
                      //   // }`}
                      //   // newTab={false}
                      // />
                    ))}
                </div>
              )}
              {isSubscriptionDealPage && (
                <div className="hidden xlg:flex items-center gap-4">
                  <button
                    className={`w-fit flex items-center justify-center gap-2 px-5 py-[12px] text-lg text-white bg-violet-500 rounded-md hover:bg-violet-500/90`}
                    onClick={() => {
                      createStripeSubscriptionUS(
                        BUSINSESS_PLAN_YEARLY_DEAL,
                        "billing_click_subscribe",
                        "Growing Business",
                        "yearly",
                        25
                      );
                    }}
                    // newTab={false}
                  >
                    Start 7 days free trial
                  </button>
                </div>
              )}
              {!isDealPage &&
                !pathname?.includes("/signature/enterprise") &&
                !pathname?.includes("/demo-booked") && (
                  <div
                    onClick={() =>
                      setSignaturePopup((prev) => ({
                        ...prev,
                        open: true,
                        mode: "register",
                      }))
                    }
                    // href={`https://signature.boloforms.com/register?from=${
                    //   context.globalData.from || "WEBSITE_NAVBAR"
                    // }`}
                    // type="button"
                    className="cursor-pointer block xlg:hidden text-black hover:text-white text-md md:text-lg border border-gray-300 bg-transparent hover:bg-violet-500 rounded-md px-4 xs:px-6 md:px-8 py-[10px] md:py-[10px] text-center transition duration-300 ease-out hover:ease-in"
                  >
                    Sign Up
                  </div>
                )}{" "}
            </div>
          )}
          {!isDealPage && (
            <button
              onClick={() => setIsMobileMenuOpen((prev) => !prev)}
              className="relative w-8 h-8 lg:hidden flex items-center justify-center focus:outline-none ml-4"
            >
              <span
                className={`absolute h-0.5 w-7 bg-black transition-transform duration-300 ease-in-out origin-center ${
                  isMobileMenuOpen
                    ? "rotate-45 translate-y-0"
                    : "-translate-y-2"
                }`}
              />
              <span
                className={`absolute h-0.5 w-7 bg-black transition-opacity duration-300 ease-in-out ${
                  isMobileMenuOpen ? "opacity-0" : "opacity-100"
                }`}
              />
              <span
                className={`absolute h-0.5 w-7 bg-black transition-transform duration-300 ease-in-out origin-center ${
                  isMobileMenuOpen
                    ? "-rotate-45 translate-y-0"
                    : "translate-y-2"
                }`}
              />
            </button>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`mt-[112px] fixed top-0 left-0 right-0 z-20   bg-white h-[calc(100vh_-_112px)] overflow-y-auto pb-4  text-left ${
          isMobileMenuOpen ? "lg:hidden block" : "hidden"
        }`}
      >
        {/* {renderProductLink && (
          <div
            onClick={() => setIsProductsMenuOpen((prev) => !prev)}
            className={`${styles.mobile_menu_item} cursor-pointer`}
          >
            Products
          </div>
        )} */}
        {renderSolutionLink && (
          <div
            onClick={() => setIsSolutionsMenuOpen((prev) => !prev)}
            className={`${styles.mobile_menu_item} cursor-pointer`}
          >
            Solutions
          </div>
        )}
        {renderFeatureLink && (
          <Link
            href={"/features"}
            onClick={() => setIsMobileMenuOpen(false)}
            className={`${styles.mobile_menu_item} cursor-pointer`}
          >
            Features
          </Link>
        )}

        {/* {isPaidProduct && ( */}
        <Fragment>
          {/* <div
              onClick={() => setIsCompareMenuOpen((prev) => !prev)}
              className={`mobile_menu_item cursor-pointer`}
            >
              Compare
            </div> */}

          {renderPricingLink &&
            !pathname?.includes(
              "/signature/not-used-lifetime-pages/lifetime-plan-new"
            ) &&
            !pathname?.includes("/signature/enterprise") && (
              <div
                className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
                onClick={handlePricingClick}
              >
                <span className="uppercase font-semibold">Pricing</span>
                <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
              </div>
            )}
        </Fragment>
        {/* )} */}

        {renderContractsLink &&
          Object.keys(contractsForNavbar).map((nav, index) => {
            const navItem =
              nav === "Real Estate"
                ? "real-estate"
                : nav === "Personal Family"
                ? "personal-family"
                : nav === "Business"
                ? "business"
                : null;
            return (
              <div
                key={index}
                rel="noreferrer"
                onClick={() => {
                  router.push(`/signature/contracts/${navItem}`);
                  setIsMobileMenuOpen(false);
                }}
                className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
              >
                <span className="uppercase font-semibold"> {nav}</span>
                <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
              </div>
            );
          })}

        {renderGuidesLink && (
          <div
            className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
            onClick={handleGuideClick}
          >
            <span className="uppercase font-semibold">Guides</span>
            <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
          </div>
        )}

        {/* {!pathname?.includes("/signature/enterprise") &&
          renderContractsNavLink && (
            <span
              onClick={() => {
                router.push("/signature/contracts");
                setIsMobileMenuOpen(false);
              }}
              target="_blank"
              rel="noreferrer"
              className={`${styles.mobile_menu_item} cursor-pointer`}
            >
              Contracts
            </span>
          )} */}
        {renderRoadmapLink && (
          <div
            onClick={handleRoadmapClick}
            className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
          >
            <span className="uppercase font-semibold">Roadmap</span>
            <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
          </div>
        )}
        {/* {renderTemplateLink && (
          <div
            onClick={() => {
              router.push("/form-templates");
              setIsMobileMenuOpen(false);
            }}
            className={`${styles.mobile_menu_item} cursor-pointer`}
          >
            Templates
          </div>
        )} */}

        {renderSecurityLink && (
          <Link
            href={`https://security.boloforms.com/`}
            onClick={() => setIsMobileMenuOpen(false)}
            rel="noreferrer"
            className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
          >
            <span className="uppercase font-semibold">Security</span>
            <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
          </Link>
        )}

        {renderBlogsLink && (
          <Link
            href={getBlogsUrl()}
            onClick={() => setIsMobileMenuOpen(false)}
            rel="noreferrer"
            className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
          >
            <span className="uppercase font-semibold">Blogs</span>
            <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
          </Link>
        )}

        {!renderContractsLink && (
          <Link
            href={"/about"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
          >
            <span className="uppercase font-semibold">About Us</span>
            <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
          </Link>
        )}

        {!renderContractsLink && (
          <Link
            href={"/customers"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
          >
            <span className="uppercase font-semibold">Case Studies</span>
            <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
          </Link>
        )}

        {renderGsuiteProducts && (
          <div className="w-full">
            <div
              rel="noreferrer"
              className={`${styles.mobile_menu_item} cursor-pointer flex justify-center items-center mx-auto`}
              onClick={() => setIsMobileGsuitProductsOpen((prev) => !prev)}
            >
              Products <MdKeyboardArrowDown className="text-xl ml-1" />
            </div>
            {isMobileGsuitProductsOpen && (
              <div className="flex flex-col gap-2 p-2 h-[120px] overflow-y-scroll scrollbar-thin">
                {gsuiteProducts.map((product, index) => (
                  <Link
                    href={product.link}
                    key={index}
                    className={`w-full group flex justify-between gap-5 p-4 border border-gray-700 rounded-xl cardBorders transition-all duration-300 ease-in-out ${
                      bgColors[index % bgColors.length] || "bg-green-100"
                    }`}
                  >
                    <div className="flex-1 flex flex-col">
                      <h1 className="text-gray-800 text-lg font-bold">
                        {product?.title}
                      </h1>
                      <h3 className="font-normal text-sm text-gray-800">
                        {product?.description}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}

        <div
          className="block text-black text-base font-medium py-3 border-b border-gray-200 px-4"
          onClick={() => {
            setSignaturePopup({ open: true, mode: "login" });
          }}
        >
          <span className="uppercase font-semibold">Sign In</span>
          <ChevronRight className="ml-1 h-5 w-5 inline-block float-right" />
        </div>

        <div
          className={`px-4 mt-5 xs:mt-12 ml-auto flex flex-col justify-center items-center `}
        >
          {/* below we have Button1 and button element */}
          {!pathname?.includes("/signature/enterprise") &&
            !pathname?.includes("/demo-booked") &&
            (is1DollarTrialCampaignState ? (
              <Button1
                btnText={"Sign In/Up"}
                bgColor={"bg-white"}
                textColor={"text-black"}
                borderRadius={"rounded-full"}
                mb={"mb-4"}
                width={"w-full"}
                height={"h-[50px]"}
              />
            ) : (
              <button
                className={`${styles.navbar_mobile_item_primary_button} mb-4 ${
                  pathname.includes("/blog-genie")
                    ? "text-green-400 border-2 border-green-400 hover:bg-green-400 hover:text-white"
                    : "text-black hover:opacity-90 border-2 border-black "
                } flex justify-center items-center gap-1 group transition-all duration-300 ease-in-out`}
                // onClick={handleSignInUp}
                onClick={() => {
                  setSignaturePopup({ open: true, mode: "register" });
                }}
              >
                <div className="">Sign Up</div>
                <HiArrowLongRight className="text-2xl group-hover:translate-x-2 transition-all duration-300 ease-in-out" />
              </button>
            ))}

          {/* {isPaidProduct && ( */}

          <button
            onClick={handleDemoClick}
            className={`${
              styles.navbar_mobile_item_primary_button
            } hover:opacity-90 ${
              pathname.includes("/blog-genie")
                ? "border-2 border-green-400 bg-green-400 text-white"
                : "bg-black text-white border-2 border-black"
            }`}
          >
            <span>Get a Free Demo</span>
          </button>
          {/* )}           */}
        </div>
      </div>
      {/* Mobile Menu End */}
      {isProductsMenuOpen && (
        <ProductList
          setIsProductsMenuOpen={setIsProductsMenuOpen}
          setIsSolutionsMenuOpen={setIsSolutionsMenuOpen}
          setIsContractsMenuOpen={setIsContractsMenuOpen}
          setIsCompareMenuOpen={setIsCompareMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
      )}
      {isSolutionsMenuOpen && (
        <Solutions
          setIsSolutionsMenuOpen={setIsSolutionsMenuOpen}
          setIsProductsMenuOpen={setIsProductsMenuOpen}
          setIsContractsMenuOpen={setIsContractsMenuOpen}
          setIsCompareMenuOpen={setIsCompareMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
      )}
      {isCompareMenuOpen && (
        <CompareList
          refs={refs}
          setIsCompareMenuOpen={setIsCompareMenuOpen}
          setIsProductsMenuOpen={setIsProductsMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
      )}

      {isContractsMenuOpen && (
        <Contracts
          currentPopUp={isContractsMenuOpen}
          setIsContractsMenuOpen={setIsContractsMenuOpen}
        />
      )}
      {isContractsMenuOpen && (
        <div
          className="w-full h-full fixed top-0 left-0 z-10 bg-black/30 lg:block hidden"
          onClick={() => {
            setIsContractsMenuOpen("");
          }}
        ></div>
      )}
      {isGsuiteProductsOpen && <GsuiteProducts />}
    </div>
  );
};

export default Navbar;

const ProductList = ({
  setIsProductsMenuOpen,
  setIsSolutionsMenuOpen,
  setIsContractsMenuOpen,
  setIsCompareMenuOpen,
  setIsMobileMenuOpen,
}) => {
  let router = useRouter();

  return (
    <div
      onMouseEnter={() => {
        setIsProductsMenuOpen(true);
        setIsContractsMenuOpen("");
        setIsSolutionsMenuOpen(false);
        setIsCompareMenuOpen(false);
        setIsMobileMenuOpen(false);
      }}
      onMouseLeave={() => {
        setIsProductsMenuOpen(false);
      }}
      style={{
        zIndex: "1000",
      }}
      className="h-[500px] overflow-y-scroll sm:overflow-y-hidden sm:h-fit products-wrapper fadeIn bg-white pt-7 pb-6 px-6 rounded-xl border shadow-lg mt-[70px] fixed top-0 left-0 mx-2 sm:mx-24"
    >
      <div className="">
        <h4 className="text-lg font-semibold uppercase text-gray-700">
          For Businesses
        </h4>
        <ProductItem
          name="Form Approvals"
          description="Create interactive workflows, approval flows & automate processes"
          image={`${BASE_ASSETS_URL}/nav/TP.svg`}
          handleOnClick={() => {
            router.push("/form-approval");
            setIsProductsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
            // setIsSolutionsMenuOpen(false);
            setIsMobileMenuOpen(false);
          }}
        />
        <ProductItem
          name="Signature"
          description="Take Signature easily within minutes"
          image={`${BASE_ASSETS_URL}/nav/14.png`}
          handleOnClick={() => {
            router.push("/signature");
            setIsProductsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
            // setIsSolutionsMenuOpen(false);
            setIsMobileMenuOpen(false);
          }}
        />
      </div>
      <hr className="py-3" />
      <div className="">
        <h4 className="text-lg font-semibold uppercase text-gray-700">
          For Institutions
        </h4>

        <ProductItem
          name="Timer+Proctor"
          description="End-to-end solution for online proctoring"
          image={`${BASE_ASSETS_URL}/nav/15.png`}
          handleOnClick={() => {
            router.push("/timer-classroom");
            setIsProductsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
            // setIsSolutionsMenuOpen(false);
            setIsMobileMenuOpen(false);
          }}
        />
      </div>
      {/* <hr className="py-3" /> */}
      {/* <div className="">
        <h4 className="text-lg font-semibold uppercase text-gray-700">Ai Tools</h4>

        <ProductItem
          name="SheetGod"
          description="AI-powered Excel magic made easy!"
          image={require("../../assets/nav/FA.svg").default}
          handleOnClick={() => {
            router.push("/sheetgod");
            setIsProductsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
            // setIsSolutionsMenuOpen(false);
            setIsMobileMenuOpen(false);
          }}
        />
        <ProductItem
          name="BlogGenie"
          description="Turn your YouTube videos into blogs using AI"
          image={require("../../assets/boloforms/blogGenie.png").default}
          handleOnClick={() => {
            router.push("/blog-genie");
            setIsProductsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
            // setIsSolutionsMenuOpen(false);
            setIsMobileMenuOpen(false);
          }}
        />
      
      </div> */}

      <div className="sm:hidden absolute right-0 top-0 m-3">
        <IoMdClose
          onClick={() => {
            setIsProductsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
          }}
          className="text-xl cursor-pointer"
        />
      </div>
    </div>
  );
};

const ProductItem = ({ name, image, description, handleOnClick }) => {
  return (
    <div
      onClick={handleOnClick}
      className="w-full mb-2.5 flex flex-row cursor-pointer  hover:bg-purple-100 p-4 rounded-xl"
    >
      <div className="mr-4 w-6 h-6 mt-1">
        <Image
          src={image}
          className="h-full w-full rounded-lg"
          width={10}
          height={10}
          loading="lazy"
          alt=""
        />
      </div>
      <div className="w-full">
        <h4 className="font-semibold mb-2">{name}</h4>
        <p className="text-sm">{description}</p>
      </div>
    </div>
  );
};

const CompareList = ({
  setIsCompareMenuOpen,
  setIsProductsMenuOpen,
  setIsMobileMenuOpen,
  refs,
}) => {
  let pathname = useLocation().pathname;

  return (
    <div
      style={{
        zIndex: "1000",
      }}
      className="text-xs sm:text-sm products-wrapper fadeIn bg-white p-6 sm:px-6 py-6 rounded-xl border shadow-lg mt-[70px] fixed top-0 mx-2 sm:mx-24"
    >
      {pathname?.includes("/form-approval") || pathname === "/" ? (
        <Fragment>
          <CompareItem
            onClick={() => {
              refs[
                pathname?.includes("pricing")
                  ? "compareFormApprovalsPricing"
                  : "compareFormApprovals"
              ]?.current?.scrollIntoView({
                behavior: "smooth",
              });
              setIsCompareMenuOpen((prev) => !prev);
              setIsProductsMenuOpen(false);
              setIsMobileMenuOpen(false);
            }}
            name="Form Approvals"
            img={require("../../assets/nav/form-approvals.png")}
          />
          <CompareItem
            onClick={() => {
              refs[
                pathname?.includes("pricing")
                  ? "comparePerFormFlowPricing"
                  : "comparePerFormFlow"
              ]?.current?.scrollIntoView({
                behavior: "smooth",
              });
              setIsCompareMenuOpen((prev) => !prev);
              setIsProductsMenuOpen(false);
              setIsMobileMenuOpen(false);
            }}
            name="PerformFlow"
            img={require("../../assets/nav/performflow.png")}
          />
        </Fragment>
      ) : (
        <Fragment>
          <CompareItem
            onClick={() => {
              refs[
                pathname?.includes("pricing")
                  ? "compareAutoProctorPricing"
                  : "compareAutoProctor"
              ]?.current?.scrollIntoView({
                behavior: "smooth",
              });
              setIsCompareMenuOpen((prev) => !prev);
              setIsProductsMenuOpen(false);
              setIsMobileMenuOpen(false);
            }}
            name="AutoProctor"
            img={require("../../assets/nav/ap-logo.svg").default}
          />
          <CompareItem
            onClick={() => {
              refs[
                pathname?.includes("pricing")
                  ? "compareQuilgoPricing"
                  : "compareQuilgo"
              ]?.current?.scrollIntoView({
                behavior: "smooth",
              });
              setIsCompareMenuOpen((prev) => !prev);
              setIsProductsMenuOpen(false);
              setIsMobileMenuOpen(false);
            }}
            name="Quilgo"
            img={require("../../assets/nav/quilgo.png")}
          />
        </Fragment>
      )}

      <div className="sm:hidden absolute right-0 top-0 m-3">
        <IoMdClose
          onClick={() => {
            setIsCompareMenuOpen((prev) => !prev);
            setIsProductsMenuOpen(false);
          }}
          className="text-xl cursor-pointer"
        />
      </div>
    </div>
  );
};

const CompareItem = ({ onClick, name, img }) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-row items-center cursor-pointer  hover:bg-purple-100 p-3 sm:p-4 rounded-xl"
    >
      <div className="flex items-center">
        <Image
          className="mr-4 h-7"
          src={require("../../assets/boloforms/logo.svg").default}
          alt=""
          loading="lazy"
        />
        <p className="font-medium">BoloForms</p>
      </div>
      <span className="mx-4 font-semibold">VS</span>
      <div className="flex flex-row items-center">
        <Image
          className="mr-4 h-6 rounded-full"
          src={img}
          alt=""
          loading="lazy"
        />
        <p className="font-medium">{name}</p>
      </div>
    </div>
  );
};

const Solutions = ({
  setIsSolutionsMenuOpen,
  setIsProductsMenuOpen,
  setIsContractsMenuOpen,
  setIsCompareMenuOpen,
  setIsMobileMenuOpen,
}) => {
  let router = useRouter();

  return (
    <div
      onMouseEnter={() => {
        setIsSolutionsMenuOpen(true);
        setIsProductsMenuOpen(false);
        setIsContractsMenuOpen("");
        setIsCompareMenuOpen(false);
        setIsMobileMenuOpen(false);
      }}
      onMouseLeave={() => {
        setIsSolutionsMenuOpen(false);
      }}
      style={{
        zIndex: "1000",
      }}
      className="h-[500px] overflow-y-scroll sm:overflow-y-hidden sm:h-fit products-wrapper fadeIn bg-white pt-7 pb-6 px-6 rounded-xl border shadow-lg mt-[70px] fixed top-0 mx-2 sm:ml-[100px]"
    >
      <ProductItem
        name="Insurance"
        description="Boloforms simplifies insurance paperwork and processes effortlessly"
        image={require("../../assets/nav/solutions/insurance.svg").default}
        handleOnClick={() => {
          router.push("/solutions/insurance");
          setIsSolutionsMenuOpen((prev) => !prev);
          setIsCompareMenuOpen(false);
          setIsMobileMenuOpen(false);
        }}
      />
      <ProductItem
        name="Real Estate"
        description="With Boloforms deal only with REAL Estate"
        image={require("../../assets/nav/solutions/realestate.svg").default}
        handleOnClick={() => {
          router.push("/solutions/real-estate");
          setIsSolutionsMenuOpen((prev) => !prev);
          setIsCompareMenuOpen(false);
          setIsMobileMenuOpen(false);
        }}
      />
      <ProductItem
        name="Healthcare"
        description="Automate Prescription Approval, Patient Intake, Employee Onboarding"
        image={require("../../assets/nav/solutions/healthcare.svg").default}
        handleOnClick={() => {
          router.push("/solutions/healthcare");
          setIsSolutionsMenuOpen((prev) => !prev);
          setIsCompareMenuOpen(false);
          setIsMobileMenuOpen(false);
        }}
      />
      <ProductItem
        name="Finance"
        description="The ultimate solution for seamless financial processes"
        image={require("../../assets/nav/solutions/finance.svg").default}
        handleOnClick={() => {
          router.push("/solutions/finance");
          setIsSolutionsMenuOpen((prev) => !prev);
          setIsCompareMenuOpen(false);
          setIsMobileMenuOpen(false);
        }}
      />
      <ProductItem
        name="Enterprise"
        description="Revolutionize enterprise operations with our cutting-edge platform."
        image={require("../../assets/nav/solutions/enterprise.svg").default}
        handleOnClick={() => {
          router.push("/solutions/enterprise");
          setIsSolutionsMenuOpen((prev) => !prev);
          setIsCompareMenuOpen(false);
          setIsMobileMenuOpen(false);
        }}
      />
      <ProductItem
        name="Startups"
        description="Empower your startup with our game-changing platform"
        image={require("../../assets/nav/solutions/startups.svg").default}
        handleOnClick={() => {
          router.push("/solutions/startups");
          setIsSolutionsMenuOpen((prev) => !prev);
          setIsCompareMenuOpen(false);
          // setIsProductsMenuOpen(false);
          setIsMobileMenuOpen(false);
        }}
      />

      <div className="sm:hidden absolute right-0 top-0 m-3">
        <IoMdClose
          onClick={() => {
            setIsSolutionsMenuOpen((prev) => !prev);
            setIsCompareMenuOpen(false);
          }}
          className="text-xl cursor-pointer"
        />
      </div>
    </div>
  );
};

const Contracts = ({ currentPopUp, setIsContractsMenuOpen }) => {
  const addHyphenInUrl = (str) => {
    return str.replace(/\s+/g, "-").toLowerCase();
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  };

  let router = useRouter();

  return (
    <div className="fixed z-50  top-[112px] xxl:left-[calc(50%_-_620px)]  mt-0 xxl:w-[1240px] lg:w-[100%] bg-white border rounded-t-0 rounded-b-2xl shadow-lg  gap-[20px] overflow-hidden lg:flex hidden">
      <div className="grid grid-cols-4">
        <div
          className={`col-span-1 py-4 px-6  bg-[#F2F1EE] border-r border-gray-200`}
        >
          <h3 className="text-2xl font-semibold">{currentPopUp}</h3>
          <p className="text-base mt-2 leading-snug">
            {contractsForNavbar[currentPopUp]?.description}
          </p>
        </div>
        <div className="col-span-3 right flex flex-col justify-between text-black">
          <h2 className="font-semibold text-xl border-b p-4">
            Top {contractsForNavbar[currentPopUp].heading} Forms
          </h2>
          <div className="grid grid-cols-4 gap-6 p-4">
            {Object.keys(contractsForNavbar[currentPopUp]?.subCategoryData).map(
              (subContract, index) => (
                <div key={index} className="flex flex-col gap-4">
                  <h4 className="text-base text-gray-700 font-semibold">
                    {subContract.toUpperCase()}
                  </h4>
                  <div className="flex flex-col gap-2 text-sm">
                    {contractsForNavbar[currentPopUp].subCategoryData[
                      subContract
                    ].map((contract, innerIndex) => (
                      <p
                        key={innerIndex}
                        className="hover:text-violet-700 cursor-pointer"
                        onClick={() => {
                          router.push(
                            `/signature/contracts/${addHyphenInUrl(
                              contractsForNavbar[currentPopUp].heading
                            )}/${generateSlug(contract.name)}`
                          );
                          setIsContractsMenuOpen("");
                        }}
                      >
                        {contract.name}
                      </p>
                    ))}
                  </div>
                </div>
              )
            )}
          </div>
          <div className="font-normal border-t p-4 pr-8 flex justify-end">
            <CLMButtonPrimaryArrow
              buttonText={contractsForNavbar[currentPopUp].heading + " Forms"}
              onClick={() => {
                router.push(
                  `/signature/contracts/${addHyphenInUrl(
                    contractsForNavbar[currentPopUp].heading
                  )}`
                );
                setIsContractsMenuOpen("");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const GsuiteProducts = () => {
  return (
    <div
      style={{
        zIndex: "1000",
      }}
      className="w-fit p-4 grid grid-cols-3 gap-4 overflow-y-hidden products-wrapper fadeIn bg-white rounded-xl border border-gray-600 shadow-lg mt-[70px] fixed top-0 left-1/2 -translate-x-1/2 mx-2"
    >
      {gsuiteProducts.map((product, index) => {
        return (
          <Link
            href={product.link}
            key={index}
            className={`w-full max-w-[200px] group flex justify-between gap-5 p-4 border border-gray-700 rounded-xl cardBorders transition-all duration-300 ease-in-out ${
              bgColors[index % bgColors.length] || "bg-green-100"
            }`}
          >
            <div className="flex-1 flex flex-col">
              <h1 className="text-gray-800 text-lg font-bold">
                {product?.title}
              </h1>
              <h3 className="font-normal text-sm text-gray-800">
                {product?.description}
              </h3>
            </div>
          </Link>
        );
      })}
    </div>
  );
};
